<mat-card appearance="outlined" class="col-md-12">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <mat-icon>notes</mat-icon>
        Notes
      </mat-card-title>
      @if (userCanEdit) {
        <button class="edit-btn" (click)="editToggle()" [matTooltip]="isEditMode ? 'Save notes' : 'Edit notes'">
          @if (!isEditMode) {
            <mat-icon>edit</mat-icon>
          }
          @if (isEditMode) {
            <mat-icon>save</mat-icon>
          }
        </button>
      }
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (!isEditMode) {
      <div>
        @if (note==null || this.noteForm.controls['noteControl'].value == null) {
          <div class="no-data">There are currently no notes for this event</div>
        }
        @if (note!==null || this.noteForm.controls['noteControl'].value !=null) {
          <div class="col">
            <p class="note-wrap">{{ this.noteForm.controls['noteControl'].value }}</p>
          </div>
        }
      </div>
    }
    @if (isEditMode) {
      <div>
        <div class="col">
          <form [formGroup]="noteForm">
            <mat-form-field>
              <mat-label>Leave a note for the event...</mat-label>
              <textarea matInput formControlName="noteControl" name="noteControl"></textarea>
            </mat-form-field>
          </form>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
